export default "__VITE_ASSET__C5NfFc8K__"